import { render } from "./Start.vue?vue&type=template&id=354421e8&scoped=true"
import script from "./Start.vue?vue&type=script&async=true&lang=js"
export * from "./Start.vue?vue&type=script&async=true&lang=js"

import "./Start.vue?vue&type=style&index=0&id=354421e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354421e8"]])

export default __exports__